export const lblCshAlreadyApplied = 'lbl_csh_already_applied';
export const lblAppliedToBag = 'lbl_csh_applied_to_bag';
export const lblValidityText = 'lbl_csh_validity_text';
export const lblErrCouponExpired = 'lbl_csh_err_coupon_expired';
export const lblErrCouponInactive = 'lbl_csh_err_coupon_inactive';
export const lblErrCouponInvalid = 'lbl_csh_err_coupon_invalid';

export const CouponDetailLabels = {
  account: {
    orders: {
      [lblCshAlreadyApplied]: 'ALREADY APPLIED TO BAG',
      [lblAppliedToBag]: 'APPLIED TO BAG',
      [lblValidityText]: 'VALID through',
      [lblErrCouponExpired]: 'expired on',
      [lblErrCouponInactive]: 'Coupon Code is inactive',
      [lblErrCouponInvalid]: 'Invalid coupon/promo code; check the spelling or try another one.',
    },
  },
};
